export const SEARCH_PLANS = "SEARCH_PLANS";
export const FILTER_PLANS = "FILTER_PLANS";
export const INCREMENT_PAGENUMBER = "INCREMENT_PAGENUMBER";
export const PLANS_DOWNLOAD = "PLANS_DOWNLOAD";
export const QUERYPARAMS = "QUERYPARAMS";

export const STATES = "STATES";
export const JURISDICTION = "JURISDICTION";
export const PLAN_TYPES = "PLAN_TYPES";
export const CODEBOOK = "CODEBOOK";

export const CRITERIA_FOR_DATATABLE = "CRITERIA_FOR_DATATABLE";

export const PLANS_DOWNLOAD_BEGIN = "PLANS_DOWNLOAD_BEGIN";
export const PLANS_DOWNLOAD_SUCCESS = "PLANS_DOWNLOAD_SUCCESS";
export const GRID_COLUMN_CHANGE = "GRID_COLUMN_CHANGE";

export const FETCH_STATELIST_BEGIN = "FETCH_STATELIST_BEGIN";
export const FETCH_JURISDICTION_BEGIN = "FETCH_JURISDICTION_BEGIN";
export const FETCH_PLANTYPES_BEGIN = "FETCH_PLANTYPES_BEGIN";
export const FETCH_CODEBOOK_BEGIN = "FETCH_CODEBOOK_BEGIN";

export const FETCH_CRITERIA_BEGIN = "FETCH_CRITERIA_BEGIN";
export const FETCH_CRITERIA_SUCCESS = "FETCH_CRITERIA_SUCCESS";
export const FETCH_CRITERIA_FAILURE = "FETCH_CRITERIA_FAILURE";

export const POST_PREFERENCE_BEGIN = "POST_PREFERENCE_BEGIN";
export const POST_PREFERENCE_SUCCESS = "POST_PREFERENCE_SUCCESS";
export const POST_PREFERENCE_FAILURE = "POST_PREFERENCE_FAILURE";

export const FETCH_PREFERENCE_BEGIN = "FETCH_PREFERENCE_BEGIN";
export const FETCH_PREFERENCE_SUCCESS = "FETCH_PREFERENCE_SUCCESS";
export const FETCH_PREFERENCE_FAILURE = "FETCH_PREFERENCE_FAILURE";

export const NEW_POST_BEGIN = "NEW_POST_BEGIN";
export const NEW_POST_SUCCESS = "NEW_POST_SUCCESS";
export const NEW_POST_FAILURE = "NEW_POST_FAILURE";

export const FILTER_PLANS_BEGIN = "FILTER_PLANS_BEGIN";
export const FILTER_PLANS_SUCCESS = "FILTER_PLANS_SUCCESS";
export const FILTER_PLANS_FAILURE = "FILTER_PLANS_FAILURE";

export const VERIFICATION_COMPLETE_BEGIN = "VERIFICATION_COMPLETE_BEGIN";
export const VERIFICATION_COMPLETE_SUCCESS = "VERIFICATION_COMPLETE_SUCCESS";
export const VERIFICATION_COMPLETE_FAILURE = "VERIFICATION_COMPLETE_FAILURE";

export const VERIFICATION_REJECT_BEGIN = "VERIFICATION_REJECT_BEGIN";
export const VERIFICATION_REJECT_SUCCESS = "VERIFICATION_REJECT_SUCCESS";
export const VERIFICATION_REJECT_FAILURE = "VERIFICATION_REJECT_FAILURE";

export const FETCH_DISCIPLINESBY_JOBID_BEGIN =
  "FETCH_DISCIPLINESBY_JOBID_BEGIN";
export const FETCH_DISCIPLINESBY_JOBID_SUCCESS =
  "FETCH_DISCIPLINESBY_JOBID_SUCCESS";
export const FETCH_DISCIPLINESBY_JOBID_FAILURE =
  "FETCH_DISCIPLINESBY_JOBID_FAILURE";

export const FETCH_VERIFICATION_DATES_BEGIN = "FETCH_VERIFICATION_DATES_BEGIN";
export const FETCH_VERIFICATION_DATES_SUCCESS =
  "FETCH_VERIFICATION_DATES_SUCCESS";
export const FETCH_VERIFICATION_DATES_FAILURE =
  "FETCH_VERIFICATION_DATES_FAILURE";

export const FETCH_VERIFICATION_ANNOTATION_BEGIN =
  "FETCH_VERIFICATION_ANNOTATION_BEGIN";
export const FETCH_VERIFICATION_ANNOTATION_NODATA =
  "FETCH_VERIFICATION_ANNOTATION_NODATA";
export const FETCH_VERIFICATION_ANNOTATION_SUCCESS =
  "FETCH_VERIFICATION_ANNOTATION_SUCCESS";
export const FETCH_VERIFICATION_ANNOTATION_FAILURE =
  "FETCH_VERIFICATION_ANNOTATION_FAILURE";

export const FETCH_VERIFICATION_ANNOTATION_STATS_BEGIN =
  "FETCH_VERIFICATION_ANNOTATION_STATS_BEGIN";
export const FETCH_VERIFICATION_ANNOTATION_STATS_SUCCESS =
  "FETCH_VERIFICATION_ANNOTATION_STATS_SUCCESS";
export const FETCH_VERIFICATION_ANNOTATION_STATS_FAILURE =
  "FETCH_VERIFICATION_ANNOTATION_STATS_FAILURE";

export const FETCH_SEARCH_RESULTS_BEGIN = "FETCH_SEARCH_RESULTS_BEGIN";
export const FETCH_SEARCH_RESULTS_SUCCESS = "FETCH_SEARCH_RESULTS_SUCCESS";
export const FETCH_SEARCH_RESULTS_FAILURE = "FETCH_SEARCH_RESULTS_FAILURE";

export const FETCH_AUTOPOPULATE_RESULTS_BEGIN =
  "FETCH_AUTOPOPULATE_RESULTS_BEGIN";
export const FETCH_AUTOPOPULATE_RESULTS_SUCCESS =
  "FETCH_AUTOPOPULATE_RESULTS_SUCCESS";
export const FETCH_AUTOPOPULATE_RESULTS_FAILURE =
  "FETCH_AUTOPOPULATE_RESULTS_FAILURE";

export const RESET_FEEDBACK = "RESET_FEEDBACK";
export const FETCH_FEEDBACK_SUCCESS = "FETCH_FEEDBACK_SUCCESS";

export const PDF_DOWNLOADER_BEGIN = "PDF_DOWNLOADER_BEGIN";
export const PDF_DOWNLOADER_SUCCESS = "PDF_DOWNLOADER_SUCCESS";
export const PDF_DOWNLOADER_FAILURE = "PDF_DOWNLOADER_FAILURE";

export const UPDATE_ANNOTATIONS_DISCARD_RESTORE =
  "UPDATE_ANNOTATIONS_DISCARD_RESTORE";

export const UPDATE_ANNOTATIONS_READ_MESSAGE =
  "UPDATE_ANNOTATIONS_READ_MESSAGE";

export const RESET_JURISDICTION = "RESET_JURISDICTION";
export const RESET_PLANTYPE = "RESET_PLANTYPE";
export const RESET_CODEBOOK = "RESET_CODEBOOK";

export const ADD_ANNOTATION_BEGUN = "ADD ANNOTATION BEGUN";
export const ADD_ANNOTATION_SUCCESS = "ADD ANNOTATION SUCCESS";
export const ADD_ANNOTATION_FAILIURE = "ADD ANNOTATION FAILURE";

export const MODIFY_ANNOTATION_BEGUN = "MODIFY ANNOTATION BEGUN";
export const MODIFY_ANNOTATION_SUCCESS = "MODIFY ANNOTATION SUCCESS";
export const MODIFY_ANNOTATION_FAILIURE = "MODIFY ANNOTATION FAILURE";

export const GET_XFDF_BEGUN = "GET XFDF BEGUN";
export const GET_XFDF_SUCCESS = "GET XFDF SUCCESS";
export const GET_XFDF_FAILIURE = "GET XFDF FAILURE";

export const GET_RECONCILIATION_REPORT_STARTED =
  "GET_RECONCILIATION_REPORT_STARTED";
export const GET_RECONCILIATION_REPORT_SUCCESS =
  "GET_RECONCILIATION_REPORT_SUCCESS";
export const GET_RECONCILIATION_REPORT_FAILURE =
  "GET_RECONCILIATION_REPORT_FAILURE";

export const GET_DOCUMENT_TYPES_SUCCESS = "GET_DOCUMENT_TYPES_SUCCESS";
export const GET_DOCUMENT_TYPES_FAILURE = "GET_DOCUMENT_TYPES_FAILURE";

export const POST_SUPPORT_DOCUMENT_BEGIN = "POST_SUPPORT_DOCUMENT_BEGIN";
export const POST_SUPPORT_DOCUMENT_SUCCESS = "POST_SUPPORT_DOCUMENT_SUCCESS";
export const POST_SUPPORT_DOCUMENT_FAILURE = "POST_SUPPORT_DOCUMENT_FAILURE";

/*Comment letter constants*/
export const GET_COMMENT_LETTER = "GET_COMMENT_LETTER";
export const GET_COMMENT_LETTER_SUCCESS = "GET_COMMENT_LETTER_SUCCESS";
export const GET_COMMENT_LETTER_FAILURE = "GET_COMMENT_LETTER_FAILURE";

export const STAMP_ENDORSEMENT_STARTED = "STAMP_ENDORSEMENT_STARTED";
export const STAMP_ENDORSEMENT_SUCCESS = "STAMP_ENDORSEMENT_SUCCESS";
export const STAMP_ENDORSEMENT_FAILURE = "STAMP_ENDORSEMENT_FAILURE";

export const GET_COMMENT_REPO_DISCIPLINES = " GET_COMMENT_REPO_DISCIPLINES";
export const GET_COMMENT_REPO_DISCIPLINES_SUCCESS =
  "GET_COMMENT_REPO_DISCIPLINES_SUCCESS";
export const GET_COMMENT_REPO_DISCIPLINES_FAILURE =
  "GET_COMMENT_REPO_DISCIPLINES_FAILURE";

export const GET_INITIAL_COMMENTS = "GET_INITIAL_COMMENTS";
export const GET_INITIAL_COMMENTS_SUCCESS = "GET_INITIAL_COMMENTS_SUCCESS";
export const GET_INITIAL_COMMENTS_FAILURE = "GET_INITIAL_COMMENTS_FAILURE";

export const GET_ADDITIONAL_DOCUMENT_SUCCESS =
  "GET_ADDITIONAL_DOCUMENT_SUCCESS";

export const GET_MORE_COMMENTS = "GET_MORE_COMMENTS";
export const GET_MORE_COMMENTS_SUCCESS = "GET_MORE_COMMENTS_SUCCESS";
export const GET_MORE_COMMENTS_FAILURE = "GET_MORE_COMMENTS_FAILURE";

export const GET_SUGGESTIONS_SUCCESS = "GET_SUGGESTIONS_SUCCESS";
export const POSSIBLE_EVIDENCE_OPEN = "POSSIBLE_EVIDENCE_OPEN";
export const POSSIBLE_EVIDENCE_CLOSE = "POSSIBLE_EVIDENCE_CLOSE";

export const CLEAR_COMMENT_LETTER = "CLEAR_COMMENT_LETTER";

export const UPDATE_ANNOTATIONDATA_NEEDSINPUT =
  "UPDATE_ANNOTATIONDATA_NEEDSINPUT";

export const UPDATE_FAVOURITE_ANNOTATIONS = "UPDATE_FAVOURITE_ANNOTATIONS";

export const filterplansBegin = () => ({
  type: FILTER_PLANS_BEGIN,
});

export const fetchStateListBegin = () => ({
  type: FETCH_STATELIST_BEGIN,
});

export const fetchJurisdictionListBegin = () => ({
  type: FETCH_JURISDICTION_BEGIN,
});

export const fetchPLantypesBegin = () => ({
  type: FETCH_PLANTYPES_BEGIN,
});

export const fetchCodebookBegin = () => ({
  type: FETCH_CODEBOOK_BEGIN,
});

export const filterplansSuccess = (res, text) => ({
  type: FILTER_PLANS_SUCCESS,
  payload: {
    text: text,
    planitems: res.data.content,
    totalPages: res.data.totalPages,
    itemsCountPerPage: res.data.size,
    totalItemsCount: res.data.totalElements,
  },
});

export const filterplansFailure = (error) => ({
  type: FILTER_PLANS_FAILURE,
  payload: { error },
});

export const fetchCriteriaBegin = () => ({
  type: FETCH_CRITERIA_BEGIN,
});

export const fetchCriteriaSuccess = (res) => ({
  type: FETCH_CRITERIA_SUCCESS,
  payload: {
    disciplines: res.data.disciplines,
    states: res.data.stateJurisdictionDto.states,
    jurisdiction: res.data.stateJurisdictionDto.jurisdictions,
    checked: false,
  },
});

export const fetchCriteriaFailure = () => ({
  type: FETCH_CRITERIA_FAILURE,
});

export const postPreferenceBegin = () => ({
  type: POST_PREFERENCE_BEGIN,
});

export const postPreferenceSuccess = (res) => ({
  type: POST_PREFERENCE_SUCCESS,
  payload: {},
});

export const postPreferenceFailure = () => ({
  type: POST_PREFERENCE_FAILURE,
});

export const fetchPreferenceBegin = () => ({
  type: FETCH_PREFERENCE_BEGIN,
});

export const fetchPreferenceSuccess = (res) => ({
  type: FETCH_PREFERENCE_SUCCESS,
  payload: {
    preference: res.data.preference,
    // disciplines: res.data.disciplines,
    // states: res.data.stateJurisdictionDto.states,
    // jurisdiction: res.data.stateJurisdictionDto.jurisdictions,
    // checked: false,
  },
});

export const fetchPreferenceFailure = () => ({
  type: FETCH_PREFERENCE_FAILURE,
});
export const fetchNewPostBegin = () => ({
  type: NEW_POST_BEGIN,
});

export const fetchNewPostSuccess = () => ({
  type: NEW_POST_SUCCESS,
});

export const fetchNewPostFailure = () => ({
  type: NEW_POST_FAILURE,
});

export const fetchVerificationCompleteBegin = () => ({
  type: VERIFICATION_COMPLETE_BEGIN,
});

export const fetchVerificationCompleteSuccess = () => ({
  type: VERIFICATION_COMPLETE_SUCCESS,
});

export const fetchVerificationCompleteFailure = () => ({
  type: VERIFICATION_COMPLETE_FAILURE,
});

export const fetchVerificationRejectBegin = () => ({
  type: VERIFICATION_REJECT_BEGIN,
});
export const fetchVerificationRejectSuccess = () => ({
  type: VERIFICATION_REJECT_SUCCESS,
});
export const fetchVerificationRejectFailure = () => ({
  type: VERIFICATION_REJECT_FAILURE,
});

export const fetchDisciplinesByJobIdBegin = () => ({
  type: FETCH_DISCIPLINESBY_JOBID_BEGIN,
});
export const fetchDisciplinesByJobIdSuccess = (res) => ({
  type: FETCH_DISCIPLINESBY_JOBID_SUCCESS,
  payload: {
    disciplines: res.data,
  },
});
export const fetchDisciplinesByJobIdFailure = () => ({
  type: FETCH_DISCIPLINESBY_JOBID_FAILURE,
});

export const fetchVerificationDatesBegin = () => ({
  type: FETCH_VERIFICATION_DATES_BEGIN,
});
export const fetchVerificationDatesSuccess = (res) => ({
  type: FETCH_VERIFICATION_DATES_SUCCESS,
  payload: {
    planName: res.data.planName,
    reasonForRejection: res.data.notes,
    planStatus: res.data.status,
    createdDate: res.data.createdDate,
    dueDate: res.data.dueDate,
    codebookName: res.data.codebookName,
    annotatedDate: res.data.annotatedDate,
    verifiedDate: res.data.verifiedDate,
    reasonForFailure: res.data.reasonForFailure,
    description: res.data.description,
    prReasonForFailure: res.data.prReasonForFailure,
    prStatus: res.data.prStatus,
    preference: res.data.preference,
  },
});
export const fetchVerificationDatesFailure = () => ({
  type: FETCH_VERIFICATION_DATES_FAILURE,
});

export const fetchVerificationAnnotationBegin = () => ({
  type: FETCH_VERIFICATION_ANNOTATION_BEGIN,
});

export const fetchVerificationAnnotationNodata = () => ({
  type: FETCH_VERIFICATION_ANNOTATION_NODATA,
});

export const fetchVerificationAnnotationSuccess = (data) => ({
  type: FETCH_VERIFICATION_ANNOTATION_SUCCESS,
  payload: {
    annotationPayload: data,
  },
});
export const fetchVerificationAnnotationFailure = () => ({
  type: FETCH_VERIFICATION_ANNOTATION_FAILURE,
});

export const fetchVerificationAnnotationStatsBegin = () => ({
  type: FETCH_VERIFICATION_ANNOTATION_STATS_BEGIN,
});

export const fetchVerificationAnnotationStatsSuccess = (res) => ({
  type: FETCH_VERIFICATION_ANNOTATION_STATS_SUCCESS,
  payload: res.data,
});
export const fetchVerificationAnnotationStatsFailure = () => ({
  type: FETCH_VERIFICATION_ANNOTATION_STATS_FAILURE,
});

export const fetchSearchResultsBegin = () => ({
  type: FETCH_SEARCH_RESULTS_BEGIN,
});

export const fetchSearchResultsSuccess = (res) => ({
  type: FETCH_SEARCH_RESULTS_SUCCESS,
  payload: {
    searchResults: res.data,
  },
});
export const fetchSearchResultsFailure = () => ({
  type: FETCH_SEARCH_RESULTS_FAILURE,
});

export const fetchAutopopulateResultsBegin = () => ({
  type: FETCH_AUTOPOPULATE_RESULTS_BEGIN,
});

export const fetchAutopopulateResultsSuccess = (res) => ({
  type: FETCH_AUTOPOPULATE_RESULTS_SUCCESS,
  payload: {
    autopopulateResults: res.data,
  },
});
export const fetchAutopopulateResultsFailure = () => ({
  type: FETCH_AUTOPOPULATE_RESULTS_FAILURE,
});

export const resetFeedback = () => ({
  type: RESET_FEEDBACK,
});

export const fetchFeedbackSuccess = (res) => ({
  type: FETCH_FEEDBACK_SUCCESS,
  payload: {
    messages: res.data.map((item) => {
      let meta = JSON.parse(item.metadata);
      meta.createdDate = item.createdDate;
      return meta;
    }),
  },
});

export const plansDownloadBegin = () => ({
  type: PLANS_DOWNLOAD_BEGIN,
});

export const plansDownloadSuccess = (res) => ({
  type: PLANS_DOWNLOAD_SUCCESS,
  payload: {
    plan_filetype: res.data,
  },
});
export const PDFDownloaderBegin = (url) => ({
  type: PDF_DOWNLOADER_BEGIN,
  payload: {
    pdfLoaderType: url,
  },
});
export const PDFDownloaderSuccess = (url) => ({
  type: PDF_DOWNLOADER_SUCCESS,
  payload: {
    pdfLoaderType: url,
  },
});
export const PDFDownloaderFailure = (url) => ({
  type: PDF_DOWNLOADER_FAILURE,
  payload: {
    pdfLoaderType: url,
  },
});
export const gridColumnChange = (column) => ({
  type: GRID_COLUMN_CHANGE,
  payload: column,
});

export const updateDiscardRestoreAnnotation = (
  id,
  isDiscarded,
  reasonForDiscard
) => ({
  type: UPDATE_ANNOTATIONS_DISCARD_RESTORE,
  payload: {
    annotationId: id,
    isDiscarded: isDiscarded,
    reasonForDiscard: reasonForDiscard,
  },
});

export const updateReadMessage = (annotationId, value) => ({
  type: UPDATE_ANNOTATIONS_READ_MESSAGE,
  payload: {
    annotationId: annotationId,
    value: value,
  },
});

export const resetJuridiction = () => ({
  type: RESET_JURISDICTION,
});

export const restPlantype = () => ({
  type: RESET_PLANTYPE,
});

export const resetCodebook = () => ({
  type: RESET_CODEBOOK,
});

export const getReconciliationReportStarted = () => ({
  type: GET_RECONCILIATION_REPORT_STARTED,
});

export const getReconciliationReportSuccess = (reconciliationReport) => ({
  type: GET_RECONCILIATION_REPORT_SUCCESS,
  payload: {
    reconciliationReport: reconciliationReport,
  },
});

export const getReconciliationReportFailure = () => ({
  type: GET_RECONCILIATION_REPORT_FAILURE,
});

export const getDocumentTypesSuccess = (data) => ({
  type: GET_DOCUMENT_TYPES_SUCCESS,
  payload: {
    documentOptions: data,
  },
});

export const getDocumentTypesFailure = () => ({
  type: GET_DOCUMENT_TYPES_FAILURE,
});

export const getCommentLetter = () => ({
  type: GET_COMMENT_LETTER,
});

/*Comment letter actions */
export const getCommentLetterSuccess = (commentLetter, id, jobId) => ({
  type: GET_COMMENT_LETTER_SUCCESS,
  payload: {
    commentLetter: commentLetter,
    id: id,
    jobId: jobId,
  },
});

export const stampEndorsementStarted = () => ({
  type: STAMP_ENDORSEMENT_STARTED,
});

export const stampEndorsementSuccess = () => ({
  type: STAMP_ENDORSEMENT_SUCCESS,
});

export const stampEndorsementFailure = () => ({
  type: STAMP_ENDORSEMENT_FAILURE,
});

export const getCommentRepoDisciplines = () => ({
  type: GET_COMMENT_REPO_DISCIPLINES,
});

export const getCommentRepoDisciplinesSuccess = (data) => ({
  type: GET_COMMENT_REPO_DISCIPLINES_SUCCESS,
  payload: {
    data: data,
  },
});

export const getInitialComments = () => ({
  type: GET_INITIAL_COMMENTS,
});

export const getInitialCommentsSuccess = (data) => ({
  type: GET_INITIAL_COMMENTS_SUCCESS,
  payload: {
    data: data,
  },
});

export const getInitialCommentsFailure = () => ({
  type: GET_INITIAL_COMMENTS_FAILURE,
});

export const getAdditionalDocumentSuccess = (data) => ({
  type: GET_ADDITIONAL_DOCUMENT_SUCCESS,
  payload: data,
});

export const getMoreCommentsBegin = () => ({
  type: GET_MORE_COMMENTS,
});

export const getMoreCommentsSuccess = (data, section) => ({
  type: GET_MORE_COMMENTS_SUCCESS,
  payload: data,
  section: section,
});

export const getMoreCommentsFailure = (data) => ({
  type: GET_MORE_COMMENTS_FAILURE,
  payload: data,
});

export const getSuggestionsSuccess = (data) => ({
  type: GET_SUGGESTIONS_SUCCESS,
  payload: data,
});

export const clearCommentletter = () => ({
  type: CLEAR_COMMENT_LETTER,
});
